export default __webpack_public_path__ + "smop-login.657443b32f2adf78427cf186a7c30a17.svg";